import { toastr } from 'react-redux-toastr';
import * as Service from '../../server/RestClients';

export const GET_LOOKUPTABLE_LOADING = 'GET_LOOKUPTABLE_LOADING';
export const GET_LOOKUPTABLE_SUCCESS = 'GET_LOOKUPTABLE_SUCCESS';
export const GET_LOOKUPTABLE_FAILURE = 'GET_LOOKUPTABLE_FAILURE';

export const getLookupTable = (config) => async (dispatch) => {
  dispatch({
    type: GET_LOOKUPTABLE_LOADING,
  });
  try {
    const lookupTable = await Service.getLookupTable(config);
    dispatch({
      type: GET_LOOKUPTABLE_SUCCESS,
      payload: lookupTable,
    });
  } catch (e) {
    toastr.error(
      'Failed to fetch lookup table',
      'Please check your connection'
    );
    dispatch({
      type: GET_LOOKUPTABLE_FAILURE,
      payload: e,
    });
  }
};
